import React, { ReactNode } from "react";

import { cn } from "@/lib/utils";

export default function RenderBlogTitle({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) {
  return (
    <h1
      className={cn(
        title.length > 80
          ? "text-xl md:text-3xl lg:text-4xl"
          : "text-3xl md:text-5xl lg:text-6xl ",
        "font-PlayfairDisplay font-semibold leading-tight tracking-tight text-white drop-shadow-sm max-w-4xl",
      )}
    >
      {children}
    </h1>
  );
}
